import React, { useEffect, useState } from "react"
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import RadioGroup from "../ReusableComponents/RadioButton";
import TextArea from "../ReusableComponents/TextArea";
import download from "../image/download.png";
import { SalaryPayHeader } from "../components/HeaderAttribute";

import { mainTable } from "../css/Common";
import GridPageWithCheckBox from "../components/GridPageWithCheckBox";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

// Utility function to format date to YYYY-MM-DD
const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return ""; // Handle invalid date
  return date.toISOString().split("T")[0]; // Returns YYYY-MM-DD
};



const StaffMasterPopup = ({ data, data1, state, countryBindDD, cityBindDD, BindSalaryPayData, selectedRows }) => {
  const selectedCountry = countryBindDD.find(
    (item) => item.value === data?.MstCountryId
  );

  const selectedState = state.find(
    (item) => item.value === data?.MstStateId
  );

  const selectedCity = cityBindDD.find(
    (item) => item.value === data?.MstCityId
  );
  return (
    <>
      <div className="px-4">
        <h2 className="text-lg font-semibold text-neutral-700 px-4 mb-4">Staff Details</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
          <InputText
            inputType="text"
            title="Employee ID"
            name="employeeID"
            classStar="text-red-500"
            content={data?.EmployeeID}
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title=" First Name"
            name="firstName"
            classStar="text-red-500"
            content={data?.FirstName}
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title=" Last Name"
            name="lastName"
            // classStar="text-red-500"
            content={data?.LastName}
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title=" Father's Name"
            name="fatherName"
            classStar="text-red-500"
            content={data?.FatherName}
            disabled={true}
            inputClassName="w-full"
          />

          <RadioGroup
            title="Gender"
            setName="gender"
            selectedOptions={parseInt(data?.MstGenderId) || ""}
            options={data1?.gender || []}
            disabled={true}
            controlFunc={() => { }}
            classStar="text-red-500"
            controlFuncBlur={() => { }}
            // tabIndex="0"
          />

          <InputText
            inputType="date"
            title="Date of Birth"
            name="dateOfBirth"
            content={data?.DateOfBirth.split("T")[0]} // Format date
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />

<InputText
            inputType="text"
            title="Address"
            name="address"
            content={data?.Address}


            disabled={true}
            inputClassName="w-full"
            placeholder="Enter Address"
            // tabIndex="0"

          />

<AutoDropDown
            title="Country"
            options={countryBindDD}
            placeholder="Select Country"
            name="country"
            selectedOption={selectedCountry}
            Class="custom-class"
            // tabIndex="1"
            classStar="text-red-500"
            disabled={true}

          />
          <AutoDropDown
            title="State"
            options={state}
            placeholder="Select State"
            name="state"
            selectedOption={selectedState}
            Class="custom-class"
            // tabIndex="1"
            classStar="text-red-500"
            disabled={true}

          />
          <AutoDropDown
            title="City"
            options={cityBindDD}
            placeholder="Select City"
            name="city"
            selectedOption={selectedCity}
            Class="custom-class"
            // tabIndex="1"
            classStar="text-red-500"
            disabled={true}

          />
  <DropDown
            name="bloodGroup"
            title="Blood Group"
            options={data1?.bloodGroup || []}
            selectedOption={data?.MstBloodGroup?.toString() || ""}
            disabled={true}
            isRequired={false}
            classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="Aadhaar Number"
            name="aadhaarNumber"
            content={data?.AadhaarNumber}
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title="PAN Number"
            name="panNumber"
            content={data?.PanNumber}
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />

<InputText
            inputType="text"
            title="Contact Number"
            name="contactNumber"
            content={data?.ContactNumber}
            disabled={true}
            classStar="text-red-500"
            inputClassName="w-full"
          />

          
<InputText
            inputType="text"
            title="Email"
            name="email"
            content={data?.Email}
            disabled={true}
            inputClassName="w-full"
          />
  <InputText
            inputType="date"
            title="Hiring Date"
            name="hiringDate"
            content={data?.HiringDate.split("T")[0]} // Format date
            disabled={true}
            inputClassName="w-full"
            classStar="text-red-500"
          />

          {/* <DropDown
            name="idProof"
            title="ID Proof"
            classStar="text-red-500"
            options={data1?.idProofType || []}
            selectedOption={data?.MstIdProofTypeId || ""}
            disabled={true}
            isRequired={false}
          />
          <InputText
            inputType="text"
            title="ID Number"
            name="idnumber"
            content={data?.IdNumber}
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          /> */}
          <DropDown
            name="position"
            title="Position"
            options={data1?.position || []}
            classStar="text-red-500"
            selectedOption={data?.MstPositionId || ""}
            disabled={true}
            isRequired={false}
          />



        
         

          <DropDown
            name="workShift"
            title="Work Shift"
            classStar="text-red-500"
            options={data1?.shiftName || []}
            selectedOption={data?.MstShiftId || ""}
            disabled={true}
            isRequired={false}
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4 mt-4">

          
        
        
        </div>

        {/* <div className="mt-4 px-4">
          <TextArea
            title="Address"
            name="address"
            content={data?.Address}
            rows={3}
            resize={false}
            disabled={true}
          />
        </div> */}
 <div className="flex mx-4">
  Image <span className="text-red-500">*</span>
 </div>
        <div className="flex mx-4">
          {data && data.Image != null && data.Image != "" && (
            <div>
              <img
                src={data ? data?.Image : download}
                alt="Image"
                className="rounded-none w-20 h-20"
              />
            </div>
          )}
        </div>

        <div className="block mb-1 p-4 text-base capitalize font-medium text-neutral-70">
          Bank Details
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">

          <InputText
            inputType="text"
            title="Bank Name"
            name="bankName"
            content={data?.BankName}
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title="Bank Branch"
            name="bankBranch"
            content={data?.BankBranch}

            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title="Account Number"
            name="accountNumber"
            content={data?.AccountNumber}
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title="IFSC Code"
            name="ifscCode"
            content={data?.IFSCCode}
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
        </div>

        <h2 className="text-lg font-semibold text-neutral-700 mt-6 px-4 mb-4">Emergency Contact Details</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
          <InputText
            inputType="text"
            title=" Emergency Contact Name"
            name="contactName"
            content={data?.ContactName}
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title="Relationship"
            name="relation"
            content={data?.Relation}
            disabled={true}
            inputClassName="w-full"
            classStar="text-red-500"
          />
          <InputText
            inputType="text"
            title="Emergency Contact Number"
            name="emergencyContactNumber"
            content={data?.EmergencyContactNumber}
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
        </div>

        {/* <div className="mt-4 px-4">
          <TextArea
            title="Emergency Address"
            name="emergencyAddress"
            content={data?.EmergencyAddress}
            rows={3}
            resize={false}
            disabled={true}
          />
        </div> */}




        {/* <div className="p-4">
          {(BindSalaryPayData?.length ?? 0) > 0 ? (
            <GridPageWithCheckBox
              header={SalaryPayHeader}
              records={BindSalaryPayData}
              selectedRows={selectedRows ?? []}
              className="w-full border border-gray-300"
              isMultiSelect={false}
              checkBoxVisible={false}
              addView={true}
            />
          ) : (
            <div className="flex items-center justify-center">
              No salary records found
            </div>
          )}
        </div> */}
      </div>
    </>
  );
};

export default StaffMasterPopup;